import { createSlice } from '@reduxjs/toolkit';

export const paymentMethodSlice = createSlice({
    name: 'payment_method',
    initialState: {
        payment_method_list: [],
        payment_method_list_select: []
    },
    reducers: {
        setPaymentMethodRedux: ( state, { payload } ) => {
            state.payment_method_list  =  payload;
        },
        setMetodoPagoSelectRedux: ( state, { payload } ) => {
            state.payment_method_list_select  =  payload;
        }
        
    }
});


// Action creators are generated for each case reducer function
export const { setPaymentMethodRedux, setMetodoPagoSelectRedux } = paymentMethodSlice.actions;